import React from 'react'
import { AssetMap } from "../../types"

interface SaveScoresProps {
  saving: boolean,
  assets: AssetMap,
  onClick()
}

export default function SaveScores({ saving, assets, onClick }: SaveScoresProps) {
  return (
    <div style={{ marginTop: "2rem", width: "100%", textAlign: "center" }}>
      <div
        onClick={onClick}
        className="action-button"
        style={{ width: "100%", maxWidth: "20rem" }}
      >
        {saving ? <img src={assets.buttonSpinner} style={{ paddingTop: "4px" }} alt="Saving..."/> : 'Save Scores'}
      </div>
    </div>

  )
}
